import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICardPurseDto, ICardPurseDtoStatusEnum } from '@/dtos';

import { CardPurseAccess } from '../ManageAccountAccessModal.types';

export const GET_CARD_PURSES_FOR_ACCESS_KEY = 'GET_CARD_PURSES_FOR_ACCESS_KEY';

export const useGetCardPurses = (employeeId?: string | number | null, enabled = true) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_CARD_PURSES_FOR_ACCESS_KEY, employeeId],
    () =>
      api.get<ICardPurseDto[]>(API_URL.CARD_PURSES, {
        params: {
          employee_id: employeeId,
        },
      }),
    {
      enabled: !!employeeId && enabled,
    }
  );

  const purses = useMemo<CardPurseAccess[]>(
    () =>
      (data?.data || [])
        .filter(
          (item) =>
            item.status === ICardPurseDtoStatusEnum.ACTIVE || item.status === ICardPurseDtoStatusEnum.FROZEN
        )
        .map((item) => ({
          id: `${item.id}`,
          accountName: item.account_name || '',
          accountType: item.account_type || '',
          status: item.status as ICardPurseDtoStatusEnum,
          isLockedByHealthPlan: !!item.is_locked_by_health_plan,
          isLockedBySystem: !!item.is_locked_by_system,
          employeeUnlockForbidden: !!item.employee_unlock_forbidden,
          lockReason: item.lock_reason,
        })),
    [data]
  );

  return { purses, isLoading, refetch };
};
